import { inject, InjectionToken } from '@angular/core';
import { WINDOW } from '@ng-web-apis/common';

export type ScrollTopFn = () => void;

export const ScrollTop = new InjectionToken<ScrollTopFn>(
  'Scroll Top function', {
    // this factory returns an arrow function that when gets fired the window will scroll to top
    factory: () => {
      // we need to inject the WINDOW before we return the arrow function
      // because this way the injection happens at compile time and not at runtime
      const window = inject(WINDOW);

      return () => window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      });
    },

    // The code below doesn't work, because this way the inject will be called at runtime
    // and the context will get lost
    // factory: () => () => inject(WINDOW).scrollTo(0, 0)
  }
);
